import _ from 'lodash'
import { getField, updateField } from 'vuex-map-fields'
import requests from '../requests'
import {
  ORGANIZATION_URL,
  ORGANIZATION_SETTINGS_URL,
  WHATSAPP_URL,
} from '@/assets/variables/endpoints'
import channels from '~/utils/channel.js'
import {
  handleHideSubmenuButton,
  isQontakLitePackage,
} from '@/utils/general.js'
import { PackageName } from '~/store/package'
import { generateCrmSignoutPayload } from '~/utils/auth'

export const state = () => ({
  dataTable: [],
  ids: '',
  organizationLists: [],
  auto_resolve: '',
  organizationDetail: {
    avatar: '',
    name: '',
    phone: '',
    email: '',
    settings: {
      waba_id: '',
    },
  },
  feature_flag: {},
  limit_ongoing_chat: {},
  app_type: null,
  permissions: {},
  companySize: 0,
  is_mekari_smart_assist_active: false,
  template_pacing: false,
  userManagement: {},
  isFetchingOrganizationSettings: false,
})

export const getters = {
  getField,
  getSmartAssistInfo(state) {
    return state.is_mekari_smart_assist_active
  },
  getPermissions(state) {
    return state.permissions
  },
}

export const actions = {
  getOrganizations({ commit, state }, params) {
    if (params.offset === 1) params.is_counted = true
    commit(
      'layouts/UPDATE_CONTENTLOADING',
      { type: 'table', status: true },
      { root: true }
    )
    requests.whatsapp
      .getService(ORGANIZATION_URL, params, {
        Authorization: this.$auth.getToken('hub'),
      })
      .subscribe(
        (res) => {
          if (params.offset === 1)
            commit('layouts/SET_TOTAL_COUNT', res.meta.pagination.total, {
              root: true,
            })
          commit('layouts/SET_META', res.meta, { root: true })
          commit('SET_DATATABLE', res.data)
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { type: 'table', status: false },
            { root: true }
          )
        },
        (err) => {
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'failed',
              message: 'Error!',
              item: err.error.messages[0],
              callback: {
                text: 'OK',
                method: 'closeNotification',
              },
            },
            { root: true }
          )
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { type: 'table', status: false },
            { root: true }
          )
        }
      )
  },
  getOrganizationLists({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      commit(
        'layouts/UPDATE_CONTENTLOADING',
        { type: 'table', status: true },
        { root: true }
      )
      requests.whatsapp
        .getService(ORGANIZATION_URL, params, {
          Authorization: this.$auth.getToken('hub'),
        })
        .subscribe(
          (res) => {
            commit('UPDATE_ORGANIZATIONLIST', res.data)
            commit(
              'layouts/UPDATE_CONTENTLOADING',
              { type: 'table', status: false },
              { root: true }
            )
            resolve(res.meta.pagination)
          },
          (err) => {
            commit(
              'layouts/UPDATE_NOTIFICATION',
              {
                display: true,
                type: 'failed',
                message: 'Error!',
                item: err.error.messages[0],
                callback: {
                  text: 'OK',
                  method: 'closeNotification',
                },
              },
              { root: true }
            )
            commit(
              'layouts/UPDATE_CONTENTLOADING',
              { type: 'table', status: false },
              { root: true }
            )
            reject(err)
          }
        )
    })
  },
  getOrganizationListsAdmin({ commit }) {
    commit(
      'layouts/UPDATE_CONTENTLOADING',
      { type: 'table', status: true },
      { root: true }
    )
    requests.whatsapp
      .getService(
        `${ORGANIZATION_SETTINGS_URL}/me`,
        {},
        { Authorization: this.$auth.getToken('hub') }
      )
      .subscribe(
        (res) => {
          commit('SET_AUTO_RESOLVE', res.data.auto_resolve)
          commit('UPDATE_ORGANIZATIONLIST', [res.data])
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { type: 'table', status: false },
            { root: true }
          )
        },
        (err) => {
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'failed',
              message: 'Error!',
              item: err.error.messages[0],
              callback: {
                text: 'OK',
                method: 'closeNotification',
              },
            },
            { root: true }
          )
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { type: 'table', status: false },
            { root: true }
          )
        }
      )
  },
  createOrganization({ commit, state, dispatch }, params) {
    commit('layouts/UPDATE_LOADINGBAR', true, { root: true })
    requests.whatsapp
      .postService(ORGANIZATION_URL, params, {
        Authorization: this.$auth.getToken('hub'),
      })
      .subscribe(
        (res) => {
          commit('layouts/UPDATE_LOADINGBAR', false, { root: true })
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'success',
              message: 'Successfully Created!',
              item: '',
              callback: {
                text: 'OK',
                method: 'refreshOrganizations',
              },
            },
            { root: true }
          )
        },
        (err) => {
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'failed',
              message: 'Error!',
              item: err.error.messages[0],
              callback: {
                text: 'OK',
                method: 'closeNotification',
              },
            },
            { root: true }
          )
          commit('layouts/UPDATE_LOADINGBAR', false, { root: true })
        }
      )
  },
  updateOrganization({ commit, state }, params) {
    commit('layouts/UPDATE_LOADINGBAR', true, { root: true })
    const myHeaders = new Headers()
    myHeaders.append('Authorization', this.$auth.getToken('hub'))

    const formdata = new FormData()
    formdata.append('id', state.organizationDetail.id)
    formdata.append('name', state.organizationDetail.name)
    formdata.append('email', state.organizationDetail.email)
    formdata.append('phone', state.organizationDetail.phone)
    if (params.editedAvatar)
      formdata.append('avatar', state.organizationDetail.avatar)
    if (state.organizationDetail.settings.waba_id)
      formdata.append('waba_id', state.organizationDetail.settings.waba_id)
    if (state.organizationDetail.settings.user_uniq_id)
      formdata.append(
        'user_uniq_id',
        state.organizationDetail.settings.user_uniq_id
      )
    if (state.organizationDetail.settings.organization_uniq_id)
      formdata.append(
        'organization_uniq_id',
        state.organizationDetail.settings.organization_uniq_id
      )

    const requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
    }

    fetch(`${ORGANIZATION_URL}/${params.id}`, requestOptions)
      .then((data) => data.json())
      .then((res) => {
        if (res.status === 'success') {
          commit('layouts/UPDATE_LOADINGBAR', false, { root: true })
          commit(
            'layouts/DISPLAY_TOAST',
            { message: 'User Succesfully Updated!' },
            { root: true }
          )
        } else {
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'failed',
              message: 'Error!',
              item: res.error.messages[0] || '',
              callback: {
                text: 'OK',
                method: 'closeNotification',
              },
            },
            { root: true }
          )
          commit('layouts/UPDATE_LOADINGBAR', false, { root: true })
        }
      })
      .catch((err) => {
        commit(
          'layouts/UPDATE_NOTIFICATION',
          {
            display: true,
            type: 'failed',
            message: 'Error!',
            item: 'code: ' + err,
            callback: {
              text: 'OK',
              method: 'closeNotification',
            },
          },
          { root: true }
        )
        commit('layouts/UPDATE_LOADINGBAR', false, { root: true })
      })
  },
  getOrganizationDetail({ commit, state }, params) {
    commit(
      'layouts/UPDATE_CONTENTLOADING',
      { type: 'content', status: true },
      { root: true }
    )
    requests.whatsapp
      .getService(
        `${ORGANIZATION_URL}/${state.ids}`,
        {},
        { Authorization: this.$auth.getToken('hub') }
      )
      .subscribe(
        (res) => {
          commit('UPDATE_DETAIL', res.data)
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { type: 'content', status: false },
            { root: true }
          )
          commit('UPDATE_AVATAR', res.data.avatar.large.url)
        },
        (err) => {
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'failed',
              message: 'Error!',
              item: err.error.messages[0],
              callback: {
                text: 'OK',
                method: 'closeNotification',
              },
            },
            { root: true }
          )
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { type: 'content', status: false },
            { root: true }
          )
        }
      )
  },
  getOrganizationSettings(
    { commit, state, rootState, rootGetters, dispatch },
    params
  ) {
    const bottommenuList = params.list.bottommenu ? params.list.bottommenu : {}
    let menuList = params.list.menu ? params.list.menu : {}
    let submenuList = params.list.submenu ? params.list.submenu : {}
    const submenuTabList = params.list.submenutab ? params.list.submenutab : {}
    const menuToDelete = []
    const submenuToDelete = []
    const submenuTabToDelete = []
    commit('SET_ORGANIZATION_SETTINGS_LOADING', true)
    return new Promise((resolve, reject) => {
      if (this.$auth.user.role !== 'super_admin') {
        requests.whatsapp
          .getService(
            `${ORGANIZATION_SETTINGS_URL}/settings`,
            {},
            { Authorization: this.$auth.getToken('hub') }
          )
          .subscribe(
            async (res) => {
              commit('UPDATE_PERMISSIONS', {
                name: 'use_new_channel_integration_page',
                value: res?.data?.use_new_channel_integration_page ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'customer_insights',
                value: res?.data?.customer_insights ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'agent_idle_rule_assignment',
                value: res?.data?.agent_idle_rule_assignment ?? false,
              })
              commit(
                'SET_MEKARI_SMART_ASSIST_STATUS',
                res?.data?.is_mekari_smart_assist_active ?? false
              )
              commit('SET_FEATURE_FLAG', res?.data ?? {})
              commit('SET_AGENT_WORKLOAD', res?.data?.limit_ongoing_chat ?? {})
              commit(
                'SET_TEMPLATE_PACING_STATUS',
                res?.data?.template_pacing ?? false
              )
              commit(
                'contact_object/contact/UPDATE_CONTACT_LIST_UPLOAD_LIMIT',
                res.data.contact_list_upload,
                { root: true }
              )
              commit('UPDATE_PERMISSIONS', {
                name: 'internal_cluster',
                value: res?.data?.internal_cluster ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'internal_cluster_redirect',
                value: res?.data?.internal_cluster_redirect ?? null,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'igComment',
                value: res?.data?.ig_comment ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'display_resolve_ig_comment',
                value: res?.data?.display_resolve_ig_comment ?? true,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'waCloud',
                value: res?.data?.wa_cloud ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'exportChat',
                value: res?.data?.download_chat_history ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'exportChatReplica',
                value: res?.data?.download_chat_history_replica ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'downloadConversation',
                value: res?.data?.download_conversation ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'dd_histogram',
                value: res?.data?.dd_histogram ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'dd_histogram_sample_rate',
                value: res?.data?.dd_histogram_sample_rate ?? 20,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'new_room_ordering_logic',
                value: res?.data?.new_room_ordering_logic ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'new_survey_flow',
                value: res?.data?.new_survey_flow ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'customer_sentiment',
                value: res?.data?.conversation_sentiment ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'chatbot_tone_of_voice',
                value: res?.data?.chatbot_tone_of_voice ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'chatbot_score_card',
                value: res?.data?.chatbot_score_card ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'chatbot_conversation_summary',
                value: res?.data?.chatbot_conversation_summary ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'is_wa_group_active',
                value: res?.data?.is_wa_group_active ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'integration_with_shopee_chat_enabled',
                value: res?.data?.integration_with_shopee_chat_enabled ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'integration_with_tokopedia_chat_enabled',
                value:
                  res?.data?.integration_with_tokopedia_chat_enabled ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'tickets_by_contact_active',
                value: res?.data?.tickets_by_contact_active ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'broadcast_log_histories',
                value: res?.data?.broadcast_log_histories ?? true,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'qontak_channel_v3',
                value: res?.data?.qontak_channel_v3 ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'wa_coexistence',
                value: res?.data?.wa_coexistence ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'embed_with_catalog',
                value: res?.data?.embed_with_catalog ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'create_message_template_otp',
                value: res?.data?.create_message_template_otp ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'message_search_revamp_ui',
                value: res?.data?.message_search_revamp_ui ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'message_search',
                value: res?.data?.message_search ?? null,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'wa_call_use_voice_service',
                value: res?.data?.wa_call_use_voice_service ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'mqtt_notification',
                value: res?.data?.mqtt_notification ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'mqtt_multitab_session',
                value: res?.data?.mqtt_multitab_session ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'new_authn_authz_mqtt',
                value: res?.data?.new_authn_authz_mqtt ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'request_old_chat_history',
                value: res?.data?.request_old_chat_history ?? null,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'enable_wa_call',
                value: res?.data?.enable_wa_call ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'disable_outbound_call',
                value: res?.data?.disable_outbound_call ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'livechat_channel_integration',
                value: res?.data?.livechat_channel_integration ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'call_activity_log',
                value: res?.data?.call_activity_log ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'prevent_do_not_auto_resolve_room',
                value: res?.data?.prevent_do_not_auto_resolve_room ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'mqtt_log',
                value: res?.data?.mqtt_log ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'email_campaign',
                value: res?.data?.email_campaign ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'revamp_inbox',
                value: res?.data?.revamp_inbox ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'sunset_inbox_v1',
                value: res?.data?.sunset_inbox_v1 ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'disable_wa_icon',
                value: res?.data?.disable_wa_icon ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'use_notification_service',
                value: res?.data?.use_notification_service ?? false,
              })
              commit(
                'fcm/UPDATE_NOTIFICATION_SERVICE_USABLE',
                res?.data?.use_notification_service ?? false,
                { root: true }
              )
              commit('UPDATE_PERMISSIONS', {
                name: 'use_notification_service',
                value: res?.data?.use_notification_service ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'qontak_one_nav',
                value: res?.data?.qontak_one_nav ?? false,
              })
              commit('UPDATE_PERMISSIONS', {
                name: 'enable_ctwa_report',
                value: res?.data?.enable_ctwa_report ?? false,
              })
              commit(
                'chat/UPDATE_AUTO_RESPONDER',
                {
                  during_office: res.data.auto_responder_in_office_hours,
                  outside_office: res.data.auto_responder_out_office_hours,
                },
                { root: true }
              )
              commit(
                'agent/UPDATE_AGENT_ALLOCATION',
                {
                  agentTakeover: res.data.agent_can_takeover,
                  agentCanAssign: res.data.agent_can_assign_agent,
                  customAllocation: res.data.custom_agent_allocation.enabled,
                  autoAllocation: res.data.auto_assign_agent,
                  webhookURL:
                    res.data.custom_agent_allocation.webhooks.length > 0
                      ? res.data.custom_agent_allocation.webhooks[0].url
                      : '',
                },
                { root: true }
              )
              commit(
                'agent/UPDATE_AGENT_CAN_BROADCAST',
                res.data.agent_can_send_broadcast,
                { root: true }
              )
              // Store agent_can_send_broadcast in preferences for sidebar access
              commit(
                'preferences/SET_AGENT_CAN_SEND_BROADCAST',
                res.data.agent_can_send_broadcast,
                { root: true }
              )
              commit(
                'agent/UPDATE_AGENT_CHAT_LIMIT',
                {
                  ...res.data.limit_ongoing_chat,
                  max: res.data.limit_ongoing_chat.enabled
                    ? res.data.limit_ongoing_chat.max
                    : '',
                },
                { root: true }
              )
              commit(
                'contact_object/contact/SET_MERGE_DEMERGE_FLAG',
                res.data.is_merge_unmerge_contact_disabled,
                { root: true }
              )

              commit('UPDATE_APP_TYPE', res.data.app_type)
              commit(
                'template/UPDATE_NEW_FB_PRICING_USAGE',
                res.data.new_fb_pricing,
                { root: true }
              )

              commit('layouts/UPDATE_APP_CHAT_FLAG', res.data.app_chat, {
                root: true,
              })
              // Fetch package config and usman config to update relevant states
              await dispatch('package/fetchPackageConfig', null, {
                root: true,
              })
              await dispatch('usman/fetchUsmanConfig', null, {
                root: true,
              })

              // Check user privilization
              if (this.$auth.user.role === 'bot') {
                params.list = {}
                params.list.homeUrl = { url: 'restricted' }
              }

              /**
               * NOTE: app_type validation
               */
              if (res.data.app_type === 'full') {
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: true, i: 0 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: true, i: 1 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: true, i: 2 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: true, i: 3 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: true, i: 4 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: true, i: 5 },
                  { root: true }
                )

                /**
                 * NOTE: add inbox menu
                 */
                const newMenuList = {}
                let newSubmenuList = {}
                newMenuList.inbox = menuList.inbox
                newSubmenuList.inbox = submenuList.inbox

                /**
                 * NOTE: always add calls menu
                 * show and hide validation will be handled by MekariSidebar.vue
                 */
                if (menuList.calls) {
                  newMenuList.calls = menuList?.calls ?? undefined
                }

                newMenuList.integrations = menuList.integrations
                newSubmenuList = {
                  ...newSubmenuList,
                  ...submenuList,
                }

                if (
                  this.$auth.user.role === 'agent' ||
                  this.$auth.user.role === 'member' ||
                  this.$auth.user.role === 'owner'
                ) {
                  dispatch('layouts/getConfiguration', {}, { root: true }).then(
                    (resAppConfig) => {
                      if (resAppConfig?.sla_dashboard_new_realtime) {
                        newMenuList.dashboard = {
                          title: 'Dashboard',
                          slug: 'dashboard',
                          status: true,
                          icon: 'dashboard',
                          redirect: '',
                          category: 0,
                        }
                      }
                      if (
                        resAppConfig?.is_show_menu_custom_solutions &&
                        params.billingInfo.is_entry_point_officeless_enabled
                      ) {
                        newMenuList.custom_solutions = {
                          title: 'Custom Solutions',
                          slug: 'custom-solutions',
                          status: true,
                          icon: 'officeless-outline',
                          redirect: 'applications',
                          category: 3,
                        }
                      }
                    }
                  )

                  // Campaign menu visibility logic
                  let canAccessCampaign = false

                  if (this.$auth.user.role === 'owner') {
                    // For owners: check USMAN permissions if enabled, otherwise default to true
                    if (rootState.usman?.isUseUsmanPermissions) {
                      canAccessCampaign = rootGetters['usman/isHasPermission'](
                        'campaign_general_view'
                      )
                    } else {
                      canAccessCampaign = true
                    }
                  } else if (this.$auth.user.role === 'member') {
                    // For members: check USMAN permissions if enabled, otherwise fall back to agent_can_send_broadcast
                    if (rootState.usman?.isUseUsmanPermissions) {
                      canAccessCampaign = rootGetters['usman/isHasPermission'](
                        'campaign_general_view'
                      )
                    } else {
                      canAccessCampaign = res.data.agent_can_send_broadcast
                    }
                  } else if (this.$auth.user.role === 'agent') {
                    // For agents: always use agent_can_send_broadcast setting
                    canAccessCampaign = res.data.agent_can_send_broadcast
                  }

                  if (canAccessCampaign) {
                    newMenuList.whatsapp = {
                      title: 'Campaign',
                      slug: 'campaign',
                      status: true,
                      icon: 'broadcast',
                      redirect: '',
                      category: 1,
                    }

                    newSubmenuList.contacts = {
                      title: 'Recipient',
                      slug: 'contacts',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'table-view-list',
                    }

                    newSubmenuList.templates = {
                      title: 'Template message ',
                      slug: 'templates',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'draft',
                    }

                    newSubmenuList.hsm = {
                      title: 'HSM Template',
                      slug: 'hsm',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'las la-business-time',
                    }

                    newSubmenuList.campaigns = {
                      title: 'Campaign',
                      slug: 'campaigns',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'broadcast',
                    }
                  }

                  // For owners, ensure they get the full menu set like admins (except campaign if no access)
                  if (this.$auth.user.role === 'owner') {
                    // Owners should get all menus that admins get, not just the limited agent/member set
                    // Don't override menuList and submenuList with the limited newMenuList/newSubmenuList
                    if (canAccessCampaign) {
                      menuList.whatsapp = newMenuList.whatsapp
                      submenuList.contacts = newSubmenuList.contacts
                      submenuList.templates = newSubmenuList.templates
                      submenuList.hsm = newSubmenuList.hsm
                      submenuList.campaigns = newSubmenuList.campaigns
                    } else {
                      // Owner doesn't have campaign access - remove campaign-related menus
                      delete menuList.whatsapp
                      delete submenuList.contacts
                      delete submenuList.templates
                      delete submenuList.hsm
                      delete submenuList.campaigns
                    }
                    // Always add dashboard if configured
                    if (newMenuList.dashboard) {
                      menuList.dashboard = newMenuList.dashboard
                    }
                    // Add unified app check for owner
                    const isUnifiedApp = rootState?.unified_app?.isUnifiedApp
                    if (isUnifiedApp) {
                      params.list.homeUrl = { url: 'home' }
                    } else {
                      params.list.homeUrl = {
                        url:
                          res.data.revamp_inbox || res.data.sunset_inbox_v1
                            ? 'inbox-v2'
                            : 'inbox',
                      }
                    }
                  } else if (this.$auth.user.role === 'member') {
                    // For members, use the limited menu set
                    menuList = newMenuList
                    submenuList = newSubmenuList
                    // Add unified app check for member
                    const isUnifiedApp = rootState?.unified_app?.isUnifiedApp
                    if (isUnifiedApp) {
                      params.list.homeUrl = { url: 'home' }
                    } else {
                      params.list.homeUrl = {
                        url:
                          res.data.revamp_inbox || res.data.sunset_inbox_v1
                            ? 'inbox-v2'
                            : 'inbox',
                      }
                    }
                  } else {
                    // For agents
                    menuList = newMenuList
                    submenuList = newSubmenuList
                  }
                } else {
                  const isUnifiedApp = rootState?.unified_app?.isUnifiedApp
                  if (isUnifiedApp) {
                    params.list.homeUrl = { url: 'home' }
                  } else {
                    params.list.homeUrl = {
                      url:
                        res.data.revamp_inbox || res.data.sunset_inbox_v1
                          ? 'inbox-v2'
                          : 'inbox',
                    }
                  }
                }
              }

              if (res.data.app_type === 'outbound') {
                menuToDelete.push('inbox')
                menuToDelete.push('contacts')
                menuToDelete.push('chatbot')
                menuToDelete.push('dashboard')
                submenuToDelete.push('contact_reports')
                if (menuList.reports && menuList.reports.redirect) {
                  menuList.reports.redirect = 'broadcast/summary'
                }
                if (
                  this.$auth.user.role === 'admin' ||
                  this.$auth.user.role === 'supervisor'
                )
                  menuList.integrations.slug = 'integrations/whatsapp'
                if (
                  this.$auth.user.role !== 'super_admin' &&
                  this.$auth.user.role !== 'admin'
                )
                  menuToDelete.push('settings')
                submenuToDelete.push('inbox')
                Object.keys(submenuList).forEach((submenu) => {
                  if (submenuList[submenu].slug === 'chatbot_usage') {
                    submenuToDelete.push(submenuList[submenu].slug)
                  }
                  if (
                    submenuList[submenu].parent === 'integrations' &&
                    submenuList[submenu].slug !== 'whatsapp'
                  )
                    submenuToDelete.push(submenuList[submenu].slug)
                  if (
                    submenuList[submenu].parent === 'reports' &&
                    submenuList[submenu].slug !== 'broadcast'
                  )
                    submenuToDelete.push(submenuList[submenu].slug)
                  if (
                    this.$auth.user.role !== 'super_admin' &&
                    this.$auth.user.role !== 'admin' &&
                    submenuList[submenu].parent === 'settings'
                  )
                    submenuTabToDelete.push(submenuList[submenu].slug)

                  if (
                    this.$auth.user.role === 'admin' &&
                    submenuList[submenu].parent === 'settings' &&
                    submenuList[submenu].slug !== 'token'
                  ) {
                    menuList.settings.slug = 'settings/token'
                    submenuToDelete.push(submenuList[submenu].slug)
                    submenuTabToDelete.push(submenuList[submenu].slug)
                  }
                })
                Object.keys(submenuTabList).forEach((submenu) => {
                  if (submenuTabList[submenu].slug !== 'campaign_reports')
                    submenuTabToDelete.push(submenuTabList[submenu].slug)
                })
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: false, i: 0 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: false, i: 1 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: true, i: 2 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: false, i: 3 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: false, i: 4 },
                  { root: true }
                )
                commit(
                  'report/UPDATE_SUBMENUS_REPORT',
                  { status: false, i: 5 },
                  { root: true }
                )

                /**
                 * NOTE: add inbox menu
                 */
                const newMenuList = {}
                const newSubmenuList = {}
                newMenuList.inbox = menuList.inbox
                newSubmenuList.inbox = submenuList.inbox

                /**
                 * NOTE: always add calls menu
                 * show and hide validation will be handled by MekariSidebar.vue
                 */
                if (menuList.calls) {
                  newMenuList.calls = menuList?.calls ?? undefined
                }

                /**
                 * NOTE: role validation
                 */
                if (
                  this.$auth.user.role !== 'agent' &&
                  this.$auth.user.role !== 'member' &&
                  this.$auth.user.role !== 'owner'
                ) {
                  params.list.homeUrl = { url: 'campaign' }
                }
                if (
                  this.$auth.user.role === 'agent' ||
                  this.$auth.user.role === 'member' ||
                  this.$auth.user.role === 'owner'
                ) {
                  // Campaign menu visibility logic
                  let canAccessCampaign = false

                  if (this.$auth.user.role === 'owner') {
                    // For owners: check USMAN permissions if enabled, otherwise default to true
                    if (rootState.usman?.isUseUsmanPermissions) {
                      canAccessCampaign = rootGetters['usman/isHasPermission'](
                        'campaign_general_view'
                      )
                    } else {
                      canAccessCampaign = true
                    }
                  } else if (this.$auth.user.role === 'member') {
                    // For members: check USMAN permissions if enabled, otherwise fall back to agent_can_send_broadcast
                    if (rootState.usman?.isUseUsmanPermissions) {
                      canAccessCampaign = rootGetters['usman/isHasPermission'](
                        'campaign_general_view'
                      )
                    } else {
                      canAccessCampaign = res.data.agent_can_send_broadcast
                    }
                  } else if (this.$auth.user.role === 'agent') {
                    // For agents: always use agent_can_send_broadcast setting
                    canAccessCampaign = res.data.agent_can_send_broadcast
                  }

                  if (canAccessCampaign) {
                    newMenuList.whatsapp = {
                      title: 'Campaign',
                      slug: 'campaign',
                      status: true,
                      icon: 'broadcast',
                      redirect: '',
                      category: 1,
                    }

                    newSubmenuList.contacts = {
                      title: 'Recipient',
                      slug: 'contacts',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'table-view-list',
                    }

                    newSubmenuList.templates = {
                      title: 'Template message ',
                      slug: 'templates',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'draft',
                    }

                    newSubmenuList.hsm = {
                      title: 'HSM Template',
                      slug: 'hsm',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'las la-business-time',
                    }

                    newSubmenuList.campaigns = {
                      title: 'Campaign',
                      slug: 'campaigns',
                      status: true,
                      parent: 'whatsapp',
                      icon: 'broadcast',
                    }

                    // Apply the same owner logic as in the full app_type section
                    if (this.$auth.user.role === 'owner') {
                      // Owners should get all menus that admins get, not just the limited agent/member set
                      // Only add campaign menus if they have access
                      if (canAccessCampaign) {
                        menuList.whatsapp = newMenuList.whatsapp
                        submenuList.contacts = newSubmenuList.contacts
                        submenuList.templates = newSubmenuList.templates
                        submenuList.hsm = newSubmenuList.hsm
                        submenuList.campaigns = newSubmenuList.campaigns
                      } else {
                        // Owner doesn't have campaign access - remove campaign-related menus
                        delete menuList.whatsapp
                        delete submenuList.contacts
                        delete submenuList.templates
                        delete submenuList.hsm
                        delete submenuList.campaigns
                      }
                      // Always add dashboard if configured
                      if (newMenuList.dashboard) {
                        menuList.dashboard = newMenuList.dashboard
                      }
                    } else {
                      // For agents and members, use the limited menu set
                      menuList = newMenuList
                      submenuList = newSubmenuList
                    }
                    params.list.homeUrl = { url: 'campaign' }
                  } else if (this.$auth.user.role === 'owner') {
                    // Owners without campaign access should still get full menu access (like admin)
                    // But redirect to inbox instead of campaign
                    params.list.homeUrl = {
                      url:
                        res.data.revamp_inbox || res.data.sunset_inbox_v1
                          ? 'inbox-v2'
                          : 'inbox',
                    }
                  } else if (
                    this.$auth.user.role === 'agent' ||
                    this.$auth.user.role === 'member'
                  ) {
                    // Agents and members without campaign access go to restricted
                    params.list.homeUrl = { url: 'restricted' }
                  }
                }
              }

              if (res.data.app_type === 'inbox') {
                Object.keys(menuList).forEach((menu) => {
                  if (menuList[menu].slug !== 'inbox')
                    menuToDelete.push(menuList[menu].slug)
                })
                Object.keys(submenuList).forEach((submenu) => {
                  if (submenuList[submenu].slug !== 'inbox')
                    submenuToDelete.push(submenuList[submenu].slug)
                })
                Object.keys(submenuTabList).forEach((submenu) => {
                  submenuTabToDelete.push(submenuTabList[submenu].slug)
                })

                /**
                 * NOTE: add inbox menu
                 */
                const newMenuList = {}
                const newSubmenuList = {}
                newMenuList.inbox = menuList.inbox
                newSubmenuList.inbox = submenuList.inbox

                /**
                 * NOTE: always add calls menu
                 * show and hide validation will be handled by MekariSidebar.vue
                 */
                if (menuList.calls) {
                  newMenuList.calls = menuList?.calls ?? undefined
                }
              }

              // New Billing Package Implementation

              // !! This decision is based on the wed 23 apr meeting.
              // !! PO decided to remove flagging setting the SLA menu from the package code
              // if (isUsePackageCode) {
              //   const isSLAEnabled = rootGetters[
              //     'package/isEnableBillingPackage'
              //   ](PackageName['CP-QONTAKCHAT-2025-0003'])

              //   if (!isSLAEnabled) {
              //     submenuToDelete.push('sla_management')
              //   }
              // }

              let channelLists = channels

              // feature flag app chat / mobile chat integration
              if (!res.data.app_chat) {
                submenuToDelete.push('mobilechat')
                channelLists = channelLists.filter((channel) => {
                  return channel.code !== 'app_chat'
                })
                if (
                  this.$auth.user.role !== 'agent' &&
                  this.$auth.user.role !== 'member'
                ) {
                  params.list.menu.integrations.redirect = 'tokopedia'
                }
              }

              channelLists.forEach((channel) => {
                if (channel.code === 'google_my_business') {
                  // Always set status - visibility will be controlled by permissions
                  channel.status = true
                }
              })

              if (!res?.data?.livechat_channel_integration) {
                channelLists = channelLists.filter((channel) => {
                  return channel.code !== 'livechat_dot_com'
                })
              }

              // store channel lists to inbox store
              commit('inbox/SET_CHANNEL_LISTS', channelLists, { root: true })

              // feature flag export conversation
              if (
                !state.permissions.exportChat &&
                !state.permissions.downloadConversation
              ) {
                submenuToDelete.push('export')
              }

              // feature flag ad campaign report
              if (!state.permissions.enable_ctwa_report) {
                submenuToDelete.push('ad_campaign')
              }

              // Custom Solutions menu toggle
              if (!params.billingInfo.is_entry_point_officeless_enabled) {
                menuToDelete.push('custom_solutions')
              }

              // feature flag customer insights
              // disabled for now, use validation in sidebar component
              // if (!state.permissions.customer_insights) {
              //   submenuToDelete.push('customer_insights')
              // }

              // Delete menu based on privilization
              menuToDelete.forEach((menu) => {
                delete menuList[menu]
              })

              submenuToDelete.forEach((menu) => {
                delete submenuList[menu]
              })

              submenuTabToDelete.forEach((menu) => {
                delete submenuTabList[menu]
              })

              const resUserMe = await dispatch(
                'template/getCredential',
                {},
                { root: true }
              )

              let newSubmenuList = handleHideSubmenuButton(submenuList, {
                me: resUserMe.data,
                settings: res.data,
              })

              // Always add Google My Business submenu - visibility will be controlled by component
              const gbrSubmenu = {
                title: 'Google My Business',
                slug: 'google-my-business',
                status: true, // Always true - component will handle filtering based on permissions
                parent: 'integrations',
                icon: 'chat',
                code: 'google-my-business',
              }
              newSubmenuList = {
                google_my_business: gbrSubmenu,
                ...newSubmenuList,
              }

              submenuList = { ...newSubmenuList }
              const showingMenu = [
                'accounts_management',
                'chat',
                'subscriptions',
              ]

              if (
                isQontakLitePackage(params.billingInfo) &&
                this.$auth.user.role === 'admin'
              ) {
                const menuListFormatted = updateMenuListRedirect(
                  menuList,
                  'settings',
                  ''
                )
                menuList = { ...menuListFormatted }

                const submenuBySettingsArrayObject = filterMenuBySpecificParent(
                  submenuList,
                  'settings'
                )
                if (submenuBySettingsArrayObject.length > 0) {
                  const submenuListFormatted = filterSubmenuByShowingMenu(
                    submenuList,
                    submenuBySettingsArrayObject,
                    showingMenu
                  )
                  submenuList = { ...submenuListFormatted }
                }
              }
              if (
                isQontakLitePackage(params.billingInfo) &&
                this.$auth.user.role === 'supervisor'
              ) {
                const menuListFormatted = updateMenuListRedirect(
                  menuList,
                  'settings',
                  ''
                )
                menuList = { ...menuListFormatted }

                const submenuBySettingsArrayObject = filterMenuBySpecificParent(
                  submenuList,
                  'settings'
                )
                if (submenuBySettingsArrayObject.length > 0) {
                  const submenuListFormatted = filterSubmenuByShowingMenu(
                    submenuList,
                    submenuBySettingsArrayObject,
                    showingMenu
                  )
                  submenuList = { ...submenuListFormatted }
                }
              }

              commit(
                'preferences/FEATURE',
                {
                  ...params.list,
                  bottommenu: bottommenuList,
                  menu: menuList,
                  submenu: submenuList,
                  submenutab: submenuTabList,
                },
                { root: true }
              )

              commit('UPDATE_PERMISSIONS', {
                name: 'bulk_update_contact',
                value: res?.data?.bulk_update_contact ?? false,
              })

              commit('UPDATE_PERMISSIONS', {
                name: 'bulk_update_contacts',
                value: res?.data?.bulk_update_contacts ?? false,
              })

              commit('UPDATE_PERMISSIONS', {
                name: 'reporting_division_filter',
                value: res?.data?.reporting_division_filter ?? false,
              })

              commit('UPDATE_PERMISSIONS', {
                name: 'knowledge_base_active',
                value: res?.data?.knowledge_base_active ?? false,
              })

              commit('UPDATE_PERMISSIONS', {
                name: 'knowledge_base_url',
                value: res?.data?.knowledge_base_url ?? false,
              })

              commit('UPDATE_PERMISSIONS', {
                name: 'enable_inbox_sla',
                value: res?.data?.enable_inbox_sla ?? false,
              })

              commit('UPDATE_PERMISSIONS', {
                name: 'security_settings',
                value: res?.data?.security_settings ?? false,
              })

              commit(
                'conversation/UPDATE_SLA_INBOX_STATUS',
                res?.data?.enable_inbox_sla ?? false,
                { root: true }
              )

              commit(
                'inbox/UPDATE_SLA_INBOX_STATUS',
                res?.data?.enable_inbox_sla ?? false,
                { root: true }
              )

              commit(
                'inbox/SET_ORGANIZATION_INBOX_POOLING',
                res?.data?.inbox_pooling ?? null,
                { root: true }
              )

              // Store the feature flag value - component will check both flag and USMAN permission
              commit('UPDATE_PERMISSIONS', {
                name: 'google_my_business',
                value: res?.data?.google_my_business ?? false,
              })

              commit('UPDATE_PERMISSIONS', {
                name: 'message_notification_ack',
                value: res?.data?.message_notification_ack ?? false,
              })

              commit(
                'inbox/UPDATE_ENABLE_GET_DIVISION_CHAT',
                res?.data?.enable_get_division_chat ?? false,
                { root: true }
              )

              const isUsePackageCode = rootState.package.isUsePackageCode
              const isSubscribeToInboxPackage = rootGetters[
                'package/isEnableBillingPackage'
              ](PackageName['CP-QONTAKCHAT-2025-0004'])

              if (isUsePackageCode && !isSubscribeToInboxPackage) {
                commit(
                  'preferences/UPDATE_PREFERENCES_BASED_ON_INBOX_PACKAGE',
                  {
                    agent_can_send_broadcast:
                      res?.data?.agent_can_send_broadcast ?? false,
                  },
                  { root: true }
                )
              }
              commit('SET_ORGANIZATION_SETTINGS_LOADING', false)
              resolve(true)
            },
            (err) => {
              if (this.$auth.user.role !== 'super_admin') {
                // getOrganizationSettings
                this.storeMixpanelMetric('[USER LOGOUT]', {
                  from: 'store/organization.js - getOrganizationSettings',
                  user_id: this.$auth.user.id,
                  organization_id: this.$auth.user.organization_id,
                  role: this.$auth.user.role,
                  email: this.$auth.user.email,
                  cid: this.$auth.company_id,
                })
                this.$auth.logout({
                  token: this.$auth.getToken('hub')?.split(' ')[1],
                  ...generateCrmSignoutPayload(),
                })
              }
              if (!params.route === 'sso-callback' && err.error.code === 401) {
                commit(
                  'layouts/UPDATE_NOTIFICATION',
                  {
                    display: true,
                    type: 'failed',
                    message: 'Error!',
                    item: err.error.messages[0],
                    callback: {
                      text: 'OK',
                      method: 'closeNotification',
                    },
                  },
                  { root: true }
                )
              }
              commit('SET_ORGANIZATION_SETTINGS_LOADING', false)
              reject(err)
            }
          )
      } else {
        commit('preferences/FEATURE', { ...params.list }, { root: true })
        commit('SET_ORGANIZATION_SETTINGS_LOADING', false)
        resolve(true)
      }
    })
  },
  syncTemplateData({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_SYNC_LOADING', { id: params.id, status: 'loading' })
      requests.whatsapp
        .postService(
          `${WHATSAPP_URL.template}/whatsapp/sync`,
          { organization_id: params.id },
          { Authorization: this.$auth.getToken('hub') }
        )
        .subscribe(
          (res) => {
            commit('UPDATE_SYNC_LOADING', {
              id: params.id,
              status: res.data.status,
            })
            setTimeout(() => {
              commit('UPDATE_SYNC_LOADING', {
                id: params.id,
                status: 'changed',
              })
            }, 2000)
            resolve(true)
          },
          (err) => {
            commit(
              'layouts/UPDATE_NOTIFICATION',
              {
                display: true,
                type: 'failed',
                message: 'Error!',
                item: err.error.messages[0],
                callback: {
                  text: 'OK',
                  method: 'closeNotification',
                },
              },
              { root: true }
            )
            commit('UPDATE_SYNC_LOADING', { id: params.id, status: false })
            reject(err)
          }
        )
    })
  },
  deleteOrganization({ commit, state, dispatch }, params) {
    commit('layouts/UPDATE_LOADINGBAR', true, { root: true })
    requests.whatsapp
      .deleteService(`${ORGANIZATION_URL}/${params.id}`, params, {
        Authorization: this.$auth.getToken('hub'),
      })
      .subscribe(
        (res) => {
          commit('layouts/UPDATE_LOADINGBAR', false, { root: true })
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'success',
              message: 'Successfully Deleted!',
              item: '',
              callback: {
                text: 'OK',
                method: 'refreshOrganizations',
              },
            },
            { root: true }
          )
        },
        (err) => {
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'failed',
              message: 'Error!',
              item: err.error.messages[0],
              callback: {
                text: 'OK',
                method: 'closeNotification',
              },
            },
            { root: true }
          )
          commit('layouts/UPDATE_LOADINGBAR', false, { root: true })
        }
      )
  },
  changeAppType({ commit, state }, params) {
    commit(
      'layouts/UPDATE_CONTENTLOADING',
      { type: 'content', status: true },
      { root: true }
    )
    requests.whatsapp
      .putService(`${ORGANIZATION_URL}/${params.id}/app_type`, params, {
        Authorization: this.$auth.getToken('hub'),
      })
      .subscribe(
        (res) => {
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { type: 'content', status: false },
            { root: true }
          )
        },
        () => {
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { status: false },
            { root: true }
          )
        }
      )
  },
  async updateAutoResolve({ commit, state }, params) {
    await commit('UPDATE_PERIOD')
    commit('layouts/UPDATE_CONTENTLOADING', { status: true }, { root: true })
    requests.whatsapp
      .putService(`${ORGANIZATION_SETTINGS_URL}/auto_resolve`, params, {
        Authorization: this.$auth.getToken('hub'),
      })
      .subscribe(
        (res) => {
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { status: false },
            { root: true }
          )
          commit('SET_AUTO_RESOLVE', res.data)
          if (res.data.is_active) {
            commit(
              'layouts/UPDATE_NOTIFICATION',
              {
                display: true,
                type: 'success',
                message: 'Successfully activate auto resolve',
                item: '',
                callback: {
                  text: 'OK',
                  method: 'closeNotification',
                },
              },
              { root: true }
            )
          } else {
            commit(
              'layouts/UPDATE_NOTIFICATION',
              {
                display: true,
                type: 'success',
                message: 'Successfully deactivate auto resolve',
                item: '',
                callback: {
                  text: 'OK',
                  method: 'closeNotification',
                },
              },
              { root: true }
            )
          }
        },
        (err) => {
          commit(
            'layouts/UPDATE_CONTENTLOADING',
            { status: false },
            { root: true }
          )
          commit(
            'layouts/UPDATE_NOTIFICATION',
            {
              display: true,
              type: 'failed',
              message: 'Error!',
              item: err.error.messages[0].active_model_errors.period[0],
              callback: {
                text: 'OK',
                method: 'closeNotification',
              },
            },
            { root: true }
          )
        }
      )
  },
  getWabaId({ commit, state }, params) {
    return new Promise((resolve) => {
      requests.whatsapp
        .getService(
          `${ORGANIZATION_SETTINGS_URL}/me`,
          {},
          { Authorization: this.$auth.getToken('hub') }
        )
        .subscribe((res) => {
          resolve(res.data.settings.waba_id)
        })
    })
  },
  getCompanySize({ commit }) {
    return new Promise((resolve) => {
      const headers = {
        Authorization: this.$auth.getToken('hub'),
      }
      this.$axios
        .get(`${ORGANIZATION_SETTINGS_URL}/metadata`, { headers })
        .then((res) => {
          commit('SET_COMPANY_SIZE', res.data.data.count_of_user)
          resolve(res.data)
        })
    })
  },
}

export const mutations = {
  SET_MEKARI_SMART_ASSIST_STATUS(state, payload) {
    state.is_mekari_smart_assist_active = payload
  },
  SET_FEATURE_FLAG(state, payload) {
    state.feature_flag = payload
  },
  SET_AGENT_WORKLOAD(state, payload) {
    state.limit_ongoing_chat = payload
  },
  SET_TEMPLATE_PACING_STATUS(state, payload) {
    state.template_pacing = payload
  },
  updateField,
  SET_DATATABLE(state, payload) {
    state.dataTable = payload
  },
  SET_AUTO_RESOLVE(state, payload) {
    const countHour = {
      hour: Math.floor(payload.period / 60),
      minutes: payload.period % 60,
    }
    state.auto_resolve = payload
    state.auto_resolve.count_hour = countHour
  },
  UPDATE_PERIOD_VALUE(state, { e, type }) {
    state.auto_resolve.count_hour[type] = Number(e.target.value)
  },
  UPDATE_ACTIVE_VALUE(state, e) {
    state.auto_resolve.is_active = e
  },
  UPDATE_PERIOD(state) {
    const period =
      state.auto_resolve.count_hour.hour * 60 +
      state.auto_resolve.count_hour.minutes
    state.auto_resolve.period = period
  },
  UPDATE_DETAIL(state, payload) {
    if (!payload.settings.waba_name) payload.settings.waba_name = ''
    state.organizationDetail = payload
  },
  SET_ORGANIZATIONLIST(state, payload) {
    state.organizationLists = payload
  },
  UPDATE_ORGANIZATIONLIST(state, payload) {
    state.organizationLists.push(...payload)
  },
  SET_ID(state, payload) {
    state.ids = payload
  },
  UPDATE_AVATAR(state, payload) {
    state.organizationDetail.avatar = payload
  },
  UPDATE_SYNC_LOADING(state, payload) {
    const index = _.findIndex(state.dataTable, { id: payload.id })
    state.dataTable[index].avatar.size = payload.status
  },
  UPDATE_APP_TYPE(state, payload) {
    state.app_type = payload
  },
  UPDATE_PERMISSIONS(state, payload) {
    state.permissions[payload.name] = payload.value
  },
  SET_COMPANY_SIZE(state, payload) {
    state.companySize = payload
  },
  UPDATE_NEW_USER_MANAGEMENT(state, payload) {
    state.userManagement = payload
  },
  SET_ORGANIZATION_SETTINGS_LOADING(state, payload) {
    state.isFetchingOrganizationSettings = payload
  },
}

function updateMenuListRedirect(menu, targetMenu, value) {
  try {
    const res = _.cloneDeep(menu)
    res[targetMenu].redirect = value
    return res
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('updateMenuListRedirect', err)
    return menu
  }
}

function filterMenuBySpecificParent(menu, parent) {
  try {
    const result = Object.entries(menu).filter(
      ([_key, value]) => value.parent === parent
    )
    return result
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('hideMenuInSubmenu', err)
    return menu
  }
}

function filterSubmenuByShowingMenu(submenu, submenuBySettings, showingMenu) {
  try {
    const submenuWillHideArrayObject = submenuBySettings.filter(
      ([key, _value]) => !showingMenu.includes(key)
    )
    const submenuWillHideArrayString = submenuWillHideArrayObject.map(
      ([key, _value]) => key
    )
    const result = hideMenuInSubmenu(submenu, submenuWillHideArrayString)
    return result
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('filterSubmenuByShowingMenu', err)
    return submenu
  }
}

function hideMenuInSubmenu(submenu, targetMenus) {
  try {
    const res = { ...submenu }
    targetMenus.forEach((menu) => {
      delete res[menu]
    })
    return res
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('hideMenuInSubmenu', err)
    return submenu
  }
}
